import { Toolbar, Typography, Box, Stack, Divider, Paper } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import "./styles.scss";
import ChipRadioGroup from "../../../components/common/RadioChip/RadioChip";
import DropDown, {
  DropdownOptions,
} from "../../../components/common/Dropdown/Dropdown";
import { getAccountByClientId } from "../../../services/transactionService";
import { LoadingButton } from "@mui/lab";
import { useClientDetails } from "../../../hooks/useClientDetails";
import { Create1099SummaryType } from "../../../types/genericType";
import useFileDownloader from "../../../hooks/useFileDownloader";
import { apiEndPoints } from "../../../variables/apiEndpoints";
import CustomSnackbar from "../../../components/common/Snackbar/CustomSnackbar";
import AutoCompleteSelect from "../../../components/common/autocompleteSelect/AutoCompleteSelect";
import AutoCompleteMultiSelect from "../../../components/common/autocompleteSelect/AutoCompleteMultiSelect";

const Summary1099 = () => {
  const { clientOptions } = useClientDetails();
  const [accountOptions, setAccountOptions] = useState<any[]>([]);
  const [createFor, setCreateFor] = useState("Individual Client");
  const [client, setClient] = useState("");
  const [account, setAccount] = useState<string[]>([""]);
  const [format, setFormat] = useState("Excel");
  const [isLoading, setIsLoading] = useState(false);
  const [year, setYear] = useState("");
  const { downloadFile } = useFileDownloader();
  const [onSuccess, setOnSuccess] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  const currentYear = new Date().getFullYear();

  const yearOptions: DropdownOptions[] = Array.from(
    { length: currentYear - 1970 + 1 },
    (_, index) => currentYear - index
  ).map((year) => ({
    label: year.toString(),
    value: year.toString(),
  }));

  useEffect(() => {
    if (client) {
      setAccountOptions([]);
      getAccountByClientId(client)
        ?.then((res: any) => {
          const accounts: any[] = [];
          res?.forEach((acc: any) => {
            accounts.push({ value: acc.id, label: acc.name });
          });
          setAccountOptions(accounts);
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  }, [client]);

  useEffect(() => {
    yearOptions.length > 0 && year === "" && setYear(yearOptions[0].value);
  }, [yearOptions]);

  const handleDownload = useCallback(async () => {
    setIsLoading(true);
    let body: Create1099SummaryType = {
      year: parseInt(year),
      format: format,
    };

    if (createFor === "All Clients (by year)") {
      body = {
        year: parseInt(year),
        format: format,
      };
    } else {
      body = {
        year: parseInt(year),
        client: client,
        account: account,
        format: format,
      };
    }
    const result = await downloadFile({
      url: `/${apiEndPoints.create1099Summary}`,
      method: "post",
      fileName: `1099Summary.csv`,
      data: body,
    });
    setIsLoading(false);
    if (!result.success) {
      setSnackbarMsg(result.errorMessage || "Error downloading file");
      setOnSuccess(true);
    }
  }, [downloadFile]);

  return (
    <>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          margin: "0px 15px",
        }}
      >
        <Typography className="profile-title">1099 Summary</Typography>
      </Toolbar>
      <Paper className="container pd-20">
        <Stack spacing={3}>
          <Typography className="title">Create 1099 Summary</Typography>
          <ChipRadioGroup
            label="Create for:"
            value={createFor}
            setValue={setCreateFor}
            options={["Individual Client", "All Clients (by year)"]}
          />
          {createFor === "Individual Client" && (
            <AutoCompleteSelect
              items={clientOptions}
              onSelectItem={setClient}
              selected={client?.toString() ?? ""}
              placeholder="Select a client"
              label="Client"
              width="326px"
              maxWidthOption="326px"
            />
          )}
          {createFor === "Individual Client" && (
            <AutoCompleteMultiSelect
              items={accountOptions}
              onSelectItem={setAccount}
              selected={account}
              placeholder="Select an account"
              label="Account"
              width="326px"
              maxWidthOption="326px"
            />
          )}
          <DropDown
            val={year}
            setVal={setYear}
            options={yearOptions}
            label="Year"
            width="93px"
            maxWidthOption="93px"
            minWidthOption="93px"
          />
          <Divider className="divider" />
          <Box className="actions">
            <ChipRadioGroup
              label="Format"
              value={format}
              setValue={setFormat}
              options={["Excel"]}
            />
            <LoadingButton
              variant="contained"
              data-testid="create1099Btn"
              size="small"
              className="submit-btn"
              onClick={handleDownload}
              loading={isLoading}
            >
              Create 1099
            </LoadingButton>
          </Box>
        </Stack>
        <CustomSnackbar
          open={onSuccess}
          message={snackbarMsg}
          setOpen={setOnSuccess}
        />
        <Divider />
      </Paper>
    </>
  );
};

export default Summary1099;
